import Select from 'react-select'

export const reactSelectStyles = {
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Arboria',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--font-size-small)',
    color: 'var(--background-blue)'
  }),
  input: (provided) => ({
    ...provided,
    fontFamily: 'Arboria',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--font-size-small)',
    color: 'var(--background-blue)'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontFamily: 'Arboria',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--font-size-small)',
    color: 'var(--background-blue)'
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: '4px',
    background: 'rgba(0, 51, 102, 0.1)'
  })
}

/**
 * @template Option
 * @template {boolean} [IsMulti=false]
 * @template {import('react-select').GroupBase<Option>} [Group=import('react-select').GroupBase<Option>]
 * @param {import('react-select').Props<Option, IsMulti, Group> & {
 *  testId?: string,
 *  disabled?: boolean
 *  onChange: (value: import('react-select').OnChangeValue<Option, IsMulti> ) => void
 * }} props
 */
export default function SelectField({ value = null, onChange, disabled, testId, ...props }) {
  return (
    <div data-testid={testId}>
      <Select isClearable={false} styles={disabled ? {} : reactSelectStyles} onChange={(newValue) => onChange(newValue || value)} value={value} isDisabled={disabled} {...props} />
    </div>
  )
}
